<template>
    <v-container grid-list-md fluid>
        <v-row class="d-flex justify-space-between mb-1">
            <v-col cols="6" class="d-flex flex-column">
                <v-row no-gutters>
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11" class="d-flex align-center">
                        <h2>Régularisations sur ventes</h2>
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    v-bind="props"
                                    size="large"
                                    class="ml-2"
                                    icon="$oss-help"
                                />
                            </template>
                            <p class="mb-0">
                                Sont affichées les régularisations non lettrées, ayant comme date
                                maximale la fin de l'exercice sélectionné.
                            </p>
                            <p class="mb-0">
                                Effectuées avec les différents outils bobbee et avec des ODs
                                manuelles.
                            </p>
                            <p class="mb-0">
                                Les ODs ne peuvent pas être rattachées à un document d'origine (les
                                2 dernières colonnes seront vides).
                            </p>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <!-- ** upload -->
                    <v-tooltip location="bottom" text="Lier un document">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-upload"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>
                    <!-- ** chat -->
                    <v-tooltip location="bottom" text="Message">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-chat"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod || validated || loading || dataLoading || !accountingPeriod
                        "
                        @click="createAdjustmentsData()"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="
                            disabledBtnGlobalValidation ||
                            loading ||
                            dataLoading ||
                            !accountingPeriod
                        "
                        @click="validateFunction()"
                        data-cy="CheckCustomersAdjustments-valid"
                        size="small"
                        class="mx-1"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>

                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                createAdjustmentsData('REVIEW');
                            "
                        />
                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                createAdjustmentsData('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>
                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                        "
                    />
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>
                        <v-list nav>
                            <v-list-item
                                v-if="auditCheckResult && auditCheckResult.id"
                                @click="deleteAuditCheckResult(auditCheckResult.id)"
                                :title="`Supprimer les commentaires et les validations du contrôle`"
                            >
                                <template #append>
                                    <v-tooltip
                                        location="bottom"
                                        text="Pour supprimer les régularisations bobbee, il faut supprimer le Cut-Off du document d'origine"
                                    >
                                        <template v-slot:activator="{ props }">
                                            <v-icon v-bind="props" size="small" icon="$oss-trash" />
                                        </template>
                                    </v-tooltip>
                                </template>
                            </v-list-item>

                            <v-list-item @click="displayActivityDialog = true">
                                <v-list-item-title>Afficher l'activité</v-list-item-title>
                                <template v-slot:append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>
        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >
            <!-- <p>accountableAccounts : {{accountableAccounts}}</p>
            <p>aaData : {{aaData}}</p> -->

            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <template v-else>
                <v-row
                    no-gutters
                    v-if="closedPeriod"
                    class="d-flex flex-column justify-center align-center mb-3"
                >
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Période clôturée</h3>
                </v-row>

                <v-row no-gutters v-if="!Object.keys(adjustments).length">
                    <v-col cols="1" />
                    <v-col cols="11" class="d-flex justify-center">
                        <h3>Aucune régularisation enregistrée ou non lettrée</h3>
                    </v-col>
                </v-row>

                <!-- // ** adjustments -->
                <v-card
                    v-if="adjustments.length"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Régularisations non lettrées</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-icon v-if="validated" class="px-2 pt-1" color="primary">
                                        $check_circle
                                    </v-icon>
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            adjustmentsExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="adjustmentsExpand = !adjustmentsExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                        <!-- <v-col cols="auto" class="align-right pa-4">
                            <v-icon v-if="validated">$oss-circle-check</v-icon>
                            <v-btn icon @click="adjustmentsExpand = !adjustmentsExpand"  style="width: 40px" class="d-inline px-2">
                                <v-icon v-if="adjustmentsExpand === false" >
                                    $fa-chevron-down
                                </v-icon>
                                <v-icon v-else >
                                    $fa-chevron-up
                                </v-icon>
                            </v-btn>
                        </v-col> -->
                    </v-row>

                    <v-card-text v-show="adjustmentsExpand" transition="expand">
                        <v-card
                            v-if="adjustments.length"
                            elevation="0"
                            style="background-color: white; border-radius: 25px"
                            class="py-6 mt-4"
                        >
                            <!-- <v-card-title
                                class="pa-0"
                                v-if="adjustments.length"
                            > -->
                            <!-- <v-switch
                                    v-model="switchIgnore"
                                    inset
                                    dense
                                    :label="`Afficher les achats ignorés`"
                                    style="text-center"
                                    color="primary"
                                    class="ml-2"
                                >
                                </v-switch> -->
                            <!-- </v-card-title> -->

                            <v-card-text class="pa-0">
                                <v-data-table
                                    :headers="adjustmentsHeaders"
                                    :items="adjustments"
                                    multi-sort
                                    :loading="loading"
                                    class="table"
                                    style="border: 1px #ededed solid"
                                >
                                    <template #no-data>Aucune anomalie</template>

                                    <template v-slot:item="props">
                                        <tr>
                                            <!-- // ** date -->
                                            <td v-if="props.item.date">
                                                {{ formatDate(props.item.date) }}
                                            </td>
                                            <td v-else>-</td>

                                            <!-- // ** thirdPartyCompany -->
                                            <td
                                                v-if="
                                                    props.item.thirdPartyCompany &&
                                                    props.item.thirdPartyCompany.name
                                                "
                                            >
                                                {{ props.item.thirdPartyCompany.name }}
                                            </td>
                                            <td v-else>-</td>

                                            <!-- // ** wording -->
                                            <td v-if="props.item.wording" class="text-left">
                                                {{ props.item.wording }}
                                            </td>
                                            <td v-else>-</td>

                                            <!-- // ** thirdPartyAccountableAccount -->
                                            <td
                                                v-if="props.item.thirdPartyAccountableAccount"
                                                class="text-center"
                                            >
                                                {{ props.item.thirdPartyAccountableAccount }}
                                            </td>
                                            <td v-else>-</td>

                                            <!-- // ** thirdPartyAccountableAccountAmountSigned -->
                                            <td
                                                v-if="
                                                    props.item
                                                        .thirdPartyAccountableAccountAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item
                                                            .thirdPartyAccountableAccountAmountSigned,
                                                        { currency: "", DC: true },
                                                    )
                                                }}
                                            </td>
                                            <td v-else>-</td>

                                            <!-- // ** goto adjustment  -->
                                            <td
                                                class="text-center pl-2 py-0"
                                                v-if="props.item.docId"
                                            >
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="openDocument(props.item.docId)"
                                                    size="x-small"
                                                    color="primary"
                                                />
                                            </td>
                                            <td v-else>-</td>

                                            <!-- // ** goto original document -->
                                            <td
                                                v-if="!props.item.originDocId"
                                                class="text-center pl-2 py-0"
                                            >
                                                <v-btn-icon
                                                    icon="$oss-eye-slash"
                                                    disabled
                                                    size="x-small"
                                                />
                                            </td>
                                            <td v-else class="text-center pl-2 py-0">
                                                <v-tooltip
                                                    v-if="props.item.acrStatus === 'TO_UPDATE'"
                                                    text="Le document d'origine a été modifié : veuillez recalculer les régularisations"
                                                >
                                                    <template v-slot:activator="{ props }">
                                                        <v-btn-warning
                                                            @click="openDocument(props.item.originDocId)"
                                                            color="error"
                                                            v-bind="props"
                                                        />
                                                    </template>
                                                </v-tooltip>

                                                <v-btn-icon
                                                    v-else
                                                    icon="$remove_red_eye"
                                                    @click="openDocument(props.item.originDocId)"
                                                    size="x-small"
                                                    color="primary"
                                                />
                                            </td>
                                        </tr>
                                    </template>

                                    <!-- data-table footer -->
                                    <template #body.append>
                                        <tr style="font-weight: bold">
                                            <th />
                                            <th />
                                            <th />
                                            <th />

                                            <th class="text-right">
                                                <h3>
                                                    {{
                                                        newCommonFormatCurrency(
                                                            previousPeriodTableSums(
                                                                "thirdPartyAccountableAccountAmountSigned",
                                                            ),
                                                            { currency: "", DC: true },
                                                        )
                                                    }}
                                                </h3>
                                            </th>

                                            <th />
                                            <th />
                                        </tr>
                                    </template>
                                </v-data-table>
                                <v-row>
                                    <v-col style="padding-bottom: 0">
                                        <v-card-title
                                            style="
                                                padding-top: 20px;
                                                padding-bottom: 0;
                                                padding-left: 0;
                                            "
                                            class="d-flex justify-end"
                                        >
                                            <v-spacer />

                                            <!-- // ** OD -->
                                            <v-btn
                                                v-if="closedPeriod || validated"
                                                rounded
                                                disabled
                                                size="small"
                                            >
                                                OD
                                            </v-btn>

                                            <v-btn
                                                v-else
                                                rounded
                                                class="btn btn_blue"
                                                @click="
                                                    createAdjustmentsData();
                                                    miscellanousOperationData = undefined;
                                                    miscellaneousOperationDialog = true;
                                                "
                                                size="small"
                                            >
                                                OD
                                            </v-btn>

                                            <!-- // ** Store data -->
                                            <v-btn
                                                v-if="closedPeriod || validated"
                                                disabled
                                                rounded
                                                class="btn btn_blue ml-2"
                                                size="small"
                                            >
                                                Enregistrer
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                rounded
                                                class="btn btn_blue ml-2"
                                                @click.stop="createAdjustmentsData()"
                                                size="small"
                                            >
                                                Enregistrer
                                            </v-btn>

                                            <!-- // ** validate -->
                                            <v-btn
                                                v-if="disabledBtnGlobalValidation"
                                                rounded
                                                class="btn btn_blue ml-2"
                                                disabled
                                                size="small"
                                            >
                                                Valider
                                            </v-btn>
                                            <v-btn
                                                v-else-if="!validated"
                                                rounded
                                                class="btn btn_blue ml-2"
                                                @click="
                                                    validated = !validated;
                                                    adjustmentsExpand = false;
                                                    createAdjustmentsData('VALIDATE');
                                                "
                                                size="small"
                                            >
                                                Valider
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                rounded
                                                class="btn btn_blue ml-2"
                                                @click="
                                                    validated = !validated;
                                                    createAdjustmentsData('UPDATE');
                                                "
                                                size="small"
                                            >
                                                Invalider
                                            </v-btn>
                                        </v-card-title>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>

                <!-- // ** connectedDocuments -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrDocuments
                        :connectedDocuments="connectedDocuments"
                        :companyId="companyId"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult || {}"
                        :accountingPeriodId="accountingPeriodId || undefined"
                        @unlinkedDocument="unlinkDocument($event)"
                        @showLinkedDocument="showLinkedDocument($event)"
                    />
                </template>

                <!-- // ** results -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrResults :results="results" :companyId="companyId" />
                </template>

                <!-- // ** comments -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires détaillés</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            commentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        "
                                        data-cy="CheckCustomersAdjustments-commentairesDetailles"
                                        @click="commentExpand = !commentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="commentExpand" transition="expand">
                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-card-text style="padding: 0">
                                    <v-textarea
                                        v-model="comment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="border: 1px #ededed solid"
                                        outlined
                                    />
                                    <!-- :key="i" -->
                                </v-card-text>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                    class="d-flex justify-end"
                                >
                                    <v-spacer />

                                    <!-- // ** OD -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        rounded
                                        disabled
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click="
                                            createAdjustmentsData();
                                            miscellanousOperationData = undefined;
                                            miscellaneousOperationDialog = true;
                                        "
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <!-- // ** Store data -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        disabled
                                        rounded
                                        class="btn btn_blue ml-2"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click.stop="createAdjustmentsData()"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>

                                    <!-- // ** validate -->
                                    <v-btn
                                        v-if="disabledBtnGlobalValidation"
                                        rounded
                                        class="btn btn_blue ml-2"
                                        disabled
                                        size="small"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else-if="!validated"
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click="
                                            validated = !validated;
                                            adjustmentsExpand = false;
                                            createAdjustmentsData('VALIDATE');
                                        "
                                        size="small"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click="
                                            validated = !validated;
                                            createAdjustmentsData('UPDATE');
                                        "
                                        size="small"
                                    >
                                        Invalider
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ** shortComment -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires synthétiques</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        data-cy="CheckCustomersAdjustments-commentairesSynthetiques"
                                        @click="shortCommentExpand = !shortCommentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="shortCommentExpand" transition="expand">
                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-card-text style="padding: 0">
                                    <v-textarea
                                        v-model="shortComment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="height: auto; border: 1px #ededed solid"
                                        outlined
                                    />
                                    <!-- :key="i" -->
                                </v-card-text>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                    class="d-flex justify-end"
                                >
                                    <v-spacer />

                                    <!-- // ** OD -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        rounded
                                        disabled
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click="
                                            createAdjustmentsData();
                                            miscellanousOperationData = undefined;
                                            miscellaneousOperationDialog = true;
                                        "
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <!-- // ** Store data -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        disabled
                                        rounded
                                        class="btn btn_blue ml-2"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click.stop="createAdjustmentsData()"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>

                                    <!-- // ** validate -->
                                    <v-btn
                                        v-if="disabledBtnGlobalValidation"
                                        rounded
                                        class="btn btn_blue ml-2"
                                        disabled
                                        size="small"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else-if="!validated"
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click="
                                            validated = !validated;
                                            adjustmentsExpand = false;
                                            createAdjustmentsData('VALIDATE');
                                        "
                                        size="small"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click="
                                            validated = !validated;
                                            createAdjustmentsData('UPDATE');
                                        "
                                        size="small"
                                    >
                                        Invalider
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ** accountableAccounts -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 v-if="auditItems.accountableAccountsRoot.length" class="pl-4">
                                    Grand livre c/{{
                                        getTextFromStringArray(auditItems.accountableAccountsRoot)
                                    }}
                                </h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        data-cy="CheckCustomersAdjustments-grandLivre"
                                        @click="generalLedgerExpand = !generalLedgerExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text
                        v-show="generalLedgerExpand"
                        transition="expand"
                        :key="refreshGeneralLedger"
                        class="pa-0"
                    >
                        <GeneralLedger
                            :companyId="companyId"
                            :accountingPeriodId="accountingPeriod.id"
                            :accountableAccountFilter="auditItems.accountableAccountsRoot"
                            :inNm1="false"
                            :hideOptions="true"
                            :withoutLetteringIfHidedOptions="true"
                            :hideBodyAppend="true"
                            :enableAuditedAccountableAccounts="true"
                        />
                    </v-card-text>
                </v-card>
                <oss-dialog
                    v-model="displayActivityDialog"
                    v-if="displayActivityDialog"
                    title="Activité"
                    valid-title="Fermer"
                    @valid="displayActivityDialog = false"
                    @close="displayActivityDialog = false"
                    min-width="60vw"
                >
                    <UsersActivitiesHistory
                        :auditCheckKey="acKey"
                        :accountingPeriodId="accountingPeriodId"
                    >
                    </UsersActivitiesHistory>
                </oss-dialog>

                <oss-dialog
                    v-model="miscellaneousOperationDialog"
                    :actions="actionsMiscellaneousOperation"
                    min-width="90vw"
                >
                    <AccountingItemEdition2
                        v-if="miscellaneousOperationDialog"
                        :companyId="companyId"
                        :prefilledRows="miscellanousOperationData"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult"
                        :accountingPeriodId="accountingPeriodId"
                        @upsert="refresh()"
                        :actions="actionsMiscellaneousOperation"
                    />
                </oss-dialog>

                <!-- <AccountingItemEdition
                    v-model="miscellaneousOperationDialog"
                    :companyId="companyId"
                    :prefilledRows="miscellanousOperationData"

                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult"
                    :accountingPeriodId="accountingPeriodId"
                    @upsert="refresh()"
                    v-if="miscellaneousOperationDialog"
                ></AccountingItemEdition> -->
                <Chat
                    :auditCheckAccountingPeriodKey="chatId"
                    v-if="openChat"
                    v-bind:chatTitle="'Chat'"
                />
                <AuditCheckDocumentsManager
                    v-model="dialogAuditCheckDocumentsManager"
                    v-if="dialogAuditCheckDocumentsManager"
                    :disabled="loading || dataLoading || !accountingPeriod"
                    :companyId="companyId"
                    :documentToDisplay="documentToDisplay"
                    :connectedDocuments="connectedDocuments || []"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    :alreadyLinkedDoc="alreadyLinkedDoc"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        alreadyLinkedDoc = false;
                        documentToDisplay = {};
                    "
                />
                <!-- :accountingItemType="'MISCELLANEOUS_OPERATION'" -->
            </template>
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { closedPeriod, formatConnectedDocuments } from "../../services/audit/AuditServices";

import { getTextFromStringArray } from "../../../../backend/src/common/audit/auditFunctions";

import GeneralLedger from "../GeneralLedger2.vue";
import AccountingItemEdition2 from "../accounting/accountingItem/Edition.vue";
import { CheckBase } from "./CheckBase";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import Chat from "../chat/Chat.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";

import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";

import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import DELETE_AUDIT_CHECK_RESULT_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultId.gql";
import { DialogAction } from "@/services/dialogAction";
import { Component, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

@Component({
    components: {
        GeneralLedger,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        AuditConnectedAcrResults,
        Chat,
        UsersActivitiesHistory,
        AccountingItemEdition2,
    },
})
export class CheckCustomersAdjustments extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;

    loading: boolean = false;
    dataLoading: boolean = true;

    dialogAuditCheckDocumentsManager: boolean = false;

    // withAccountingPeriod: boolean = false;
    // accountingPeriodEnd: string = ""

    auditCheckResultId: string = "";
    auditCheckResult: any = null;

    noResults: boolean = false;
    validated: boolean = false;
    comment: string = "";
    shortComment: string = "";

    miscellaneousOperationDialog: boolean = false;
    miscellanousOperationData: Array<any> = [];
    previousPeriodDocuments: any = {};
    nextPeriodDocuments: any = {};

    adjustmentsExpand: boolean = true;
    commentExpand: boolean = false;
    shortCommentExpand: boolean = false;
    generalLedgerExpand: boolean = false;

    refreshGeneralLedger: number = 0;

    alreadyLinkedDoc: boolean = false;

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    // get selectedCompany() {
    //     return this.$store.getters.getCompany(this.companyId);
    // }

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    accountingTransactions: Array<any> = [];
    withoutLettering: boolean = false;
    withoutBank: boolean = false;
    withoutDocument: boolean = false;

    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    getTextFromStringArray(array: Array<string>) {
        return getTextFromStringArray(array);
    }

    // ///////// CUSTOMERS SETTINGS /////////////////
    // key: string = "eZZcPLQGRZHBLwNM34gpkRpg"

    // ////////////////////////////////////////////////

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
    }

    // afterAccountingPeriodFound() {
    // }

    // ++++++++++++++++++ ACCOUNTING LINES and AUDIT CHECK RESULT +++++++++++++
    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId || undefined,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.dataLoading = true;
                if (data.auditItems && data.auditItems.items && data.auditItems.items[0]) {
                    this.auditItems = data.auditItems.items[0];

                    if (this.auditItems.thisPeriodAndCustomerAuditCheckResult?.[0]?.id) {
                        this.auditCheckResult =
                            this.auditItems.thisPeriodAndCustomerAuditCheckResult[0];
                        this.auditCheckResultId = this.auditCheckResult.id;

                        if (this.auditCheckResult.documents) {
                            this.connectedDocuments = this.auditCheckResult.documents;
                        }

                        if (this.auditCheckResult.results) {
                            this.results = this.auditCheckResult.results;
                        }

                        if (this.auditCheckResult.reviewed) {
                            this.reviewed = this.auditCheckResult.reviewed;
                        }

                        this.aaData = this.auditCheckResult.data?.[0];
                        if (this.aaData) {
                            this.comment = this.aaData.comment || "";
                            this.shortComment = this.aaData.shortComment || "";
                            this.validated = this.aaData.validated || false;
                        }
                    } else {
                        this.auditCheckResultId = "";
                        this.comment = "";
                        this.shortComment = "";
                        this.validated = false;
                    }

                    if (this.auditItems.adjustments) {
                        this.adjustments = this.auditItems.adjustments;
                    }

                    if (this.auditItems.adjustmentsHeaders) {
                        this.adjustmentsHeaders = this.auditItems.adjustmentsHeaders;
                        this.adjustmentsHeaders.forEach((element) => {
                            element.title = element.text;
                        });
                    }

                    // ** GeneralLedger - accountableAccounts
                    if (this.auditItems.accountableAccounts.length) {
                        this.accountableAccounts = this.auditItems.accountableAccounts;
                    }

                    // if (this.auditItems.auditCheckResult && this.auditItems.auditCheckResult.id) {
                    // **** data : stored match lines **************
                    // this.auditCheckResultId = this.auditItems.auditCheckResult.id

                    // if (this.auditItems.accountableAccounts.length) {
                    //     this.accountableAccounts = this.auditItems.accountableAccounts
                    // }

                    // **** data : stored match lines **************
                    // ** comments - validated
                    //     if (this.auditItems.auditCheckResult.data && this.auditItems.auditCheckResult.data[0]) {
                    //         this.aaData = this.auditItems.auditCheckResult.data[0]
                    //         if (this.aaData) {
                    //             this.comment = this.aaData.comment || ""
                    //             this.validated = this.aaData.validated || false
                    //         }
                    //     }
                    // } else {
                    //     this.createAdjustmentsData()
                    // }
                }
                this.dataLoading = false;
            } else {
                this.initialiseCompany();
            }
        },
    })
    auditItems: any;

    adjustments: any = [];

    adjustmentsHeaders: any = [];

    accountableAccounts: any = [];

    aaData: Array<any> = [];

    reviewed: number = 0;

    async fetchTotals(detailledBalanceInfos) {
        if (this.accountableAccounts.length) {
            if (detailledBalanceInfos.aaName) {
                const foundedAA = this.accountableAccounts.find(
                    (aa) => aa.name === detailledBalanceInfos.aaName,
                );
                if (foundedAA) {
                    const indexFoundedAA = this.accountableAccounts.indexOf(foundedAA);

                    this.accountableAccounts[indexFoundedAA].queryLength =
                        detailledBalanceInfos.queryLength;

                    this.accountableAccounts[indexFoundedAA].aaName = detailledBalanceInfos.aaName;

                    this.accountableAccounts[indexFoundedAA].totalBalance =
                        detailledBalanceInfos.totalBalance;

                    // this.accountableAccounts[indexFoundedAA].totalCredit = detailledBalanceInfos.totalCredit
                    // this.accountableAccounts[indexFoundedAA].totalDebit = detailledBalanceInfos.totalDebit
                }

                // eslint-disable-next-line no-prototype-builtins
                const allFetchsDone = this.accountableAccounts.every((accAccount) =>
                    accAccount.hasOwnProperty("queryLength"),
                );

                if (allFetchsDone) {
                    // *** if any lines received
                    const noQueryLengths = !this.accountableAccounts.some(
                        (accAccount) => accAccount.queryLength > 0,
                    );
                    if (noQueryLengths) {
                        this.noResults = true;
                    } else if (!this.auditCheckResultId) {
                        this.createAdjustmentsData();
                    }
                }
            }
        } else {
            debugger; // git-ignore
            // // TO BE DONE : if detailledBalanceInfos.aaConditions
        }
    }

    // ++++++++++++++ UPSERT +++++++++++++++
    async createAdjustmentsData(action = undefined) {
        const data = [
            {
                comment: this.comment || "",
                shortComment: this.shortComment || "",
                validated: this.validated || false,
            },
        ];

        let auditCheckResultVariables: any = {};

        if (this.acKey && this.companyId && this.accountingPeriodId) {
            auditCheckResultVariables = {
                id:
                    this.auditCheckResultId && this.auditCheckResultId.length
                        ? this.auditCheckResultId
                        : "",
                key: this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId,
                companyId: this.companyId,
                // thirdPartyCompany: {connect: {id: this.selectedCustomer.id}},
                status: this.validated ? "VALIDATED" : "EDITION",
                // thirdPartyCompanyCreate: al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id ? { connect: { id:al.object.thirdPartyCompany.id } } : undefined,
                // thirdPartyCompanyUpdate: al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id ? { connect: { id:al.object.thirdPartyCompany.id } } : undefined,
                accountingPeriodCreate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                accountingPeriodUpdate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                data: JSON.parse(JSON.stringify(data)) || undefined,
                auditCheckKey: this.acKey,
                type: "IN_AUDIT_REPORT",
                // deleteDocuments: [], // ** previous results, if to delete
                // documents: [],  // ** results = générés par le contrôle
                connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
                reviewed: this.reviewed,
            };
        }
        if (auditCheckResultVariables) {
            await this.$apollo.mutate({
                mutation: UPSERT_AUDIT_CHECK_RESULT,
                variables: auditCheckResultVariables,
            });
        }

        // await this.createUserActivity(action) // deprecated

        // ++++++++++++++ RESET +++++++++++++++++++
        this.refresh();
    }

    async deleteAuditCheckResult(acrId) {
        const deletedACR = await this.$apollo.mutate({
            mutation: DELETE_AUDIT_CHECK_RESULT_AND_RESULTS,
            variables: { id: acrId },
        });

        if (deletedACR) {
            this.refresh();
        }
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.auditItems) {
            this.$apollo.queries.auditItems.refetch();
            // if (this.accountableAccounts.length) {
            //     for (const aa of this.accountableAccounts) {
            //         this.fetchTotals(aa.detailledBalanceInfos)
            //     }
            // }
        } else {
            debugger; // git-ignore
        }

        this.initialiseCompany();
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    async validateFunction() {
        if (!this.validated) {
            this.validated = !this.validated;
            await this.createAdjustmentsData("VALIDATE");
        } else {
            this.validated = !this.validated;
            this.reviewed = 0;
            await this.createAdjustmentsData("UPDATE");
        }
    }

    openDocument(id) {
        if (id) {
            this.$router.push({
                name: "document",
                params: {
                    companyId: this.companyId,
                    id: id,
                },
            });
        }
    }

    previousPeriodTableSums(key) {
        // sum data in give key (property)
        if (this.adjustments && this.adjustments.length > 0) {
            return this.adjustments.reduce((a, b) => a + (b[key] || 0), 0);
        }
        return 0;
    }

    aaExpand(accountableAccount) {
        accountableAccount.expand = !accountableAccount.expand;
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
    }

    get disabledBtnGlobalValidation() {
        if (this.accountingPeriod?.closed) {
            return true;
        }

        if (this.adjustments?.length) {
            const modifiedAccountingLine = this.adjustments.some(
                (c) => c.acrStatus === "TO_UPDATE",
            );
            if (modifiedAccountingLine) {
                if (this.validated) {
                    this.validated = false;
                    this.createAdjustmentsData();
                }
                return true;
            }
        }
        return false;
    }

    initialiseCompany() {
        this.adjustments = {};
        this.accountableAccounts = [];
        this.aaData = [];
    }
}

export default toNative(CheckCustomersAdjustments);
</script>
